import React from "react";
import { useLocation } from "react-router-dom";

import {
  ProductContainer,
  ViewContainer,
  ContentContainer,
  SwitchRoutes,
  SubNav,
  StandaloneAppWrapper,
  BrandedDocumentTitle
} from "@akj-dev/affinity-suite";

import { routes } from "./routes";

const AppStandaloneComponent = () => {
  const { pathname } = useLocation();

  return (
    <ProductContainer>
      <BrandedDocumentTitle title="Billing" />
      {pathname.includes(routes.rootPath) && (
        <SubNav routes={routes} rootTitle="Billing" />
      )}
      <ViewContainer>
        <ContentContainer>
          <SwitchRoutes routes={routes} />
        </ContentContainer>
      </ViewContainer>
    </ProductContainer>
  );
};
export const AppStandalone = () => (
  <StandaloneAppWrapper root={routes.rootPath}>
    <AppStandaloneComponent />
  </StandaloneAppWrapper>
);
